<template>
  <div>
    <!-- <button @click="getList">打开小程序</button>
    <button @click="getList">打开小程序苹果</button> -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      imgList: [
        'https://oss.aqdpay.com/appweb/activeimg/dtactive/1.png',
        'https://oss.aqdpay.com/appweb/activeimg/dtactive/2.png',
        'https://oss.aqdpay.com/appweb/activeimg/dtactive/3.png'
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      location.href = 'weixin://dl/business/?t=i5Dnff7Saik'
    }
  }
}
</script>
<style lang="scss" scoped>
.img-box {
  display: block;
  width: 100%;
}
</style>
